import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-332e082a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Регистрация", -1))
const _hoisted_3 = {
  key: 0,
  class: "text"
}
const _hoisted_4 = {
  key: 1,
  class: "auth-form-components"
}
const _hoisted_5 = { class: "flex flex-col input-labeled" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "E-mail", -1))
const _hoisted_7 = { class: "flex flex-col input-labeled" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Пароль", -1))
const _hoisted_9 = { class: "flex flex-col input-labeled" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fname" }, "Имя", -1))
const _hoisted_11 = { class: "flex flex-col input-labeled" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lname" }, "Фамилия", -1))
const _hoisted_13 = { class: "flex flex-col input-labeled" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "organization_name" }, "Название организации", -1))
const _hoisted_15 = {
  key: 0,
  class: "bad-msg"
}
const _hoisted_16 = { class: "after-info" }
const _hoisted_17 = { class: "forgot" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "has-account" }, "Есть аккаунт?", -1))
const _hoisted_19 = {
  key: 2,
  class: "fl-senter m-t-5"
}

import { computed, ref, onMounted, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth/login";
import { rootGetters } from "@/main";

import InputText from "primevue/inputtext";
import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";
import Password from "primevue/password";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupForm',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();
const isProgress = ref(false);
const errorMessage = ref("");
const invalid = ref(false);
const invalidEmail = ref(false);
const invalidPassword = ref(false);
const requestSent = ref(false);

const form = ref({
  email: "",
  password: "",
  fname: "",
  lname: "",
  organization_name: "",
});

const isSuccessMessageVisible = computed(() => requestSent.value);

const redirectIfAuthorized = async () => {
  if (!requestSent.value || !localStorage.getItem("access_token")) return;

  await authStore.getUserInfo();
  const startPage = authStore.getStartPage();
  router.push(startPage);
};

const onStorage = (event: StorageEvent) => {
  if (event.key === "access_token" && event.newValue) {
    redirectIfAuthorized();
  }
};

onMounted(() => {
  window.addEventListener("storage", onStorage);
  document.addEventListener("visibilitychange", redirectIfAuthorized);
});

onBeforeUnmount(() => {
  window.removeEventListener("storage", onStorage);
  document.removeEventListener("visibilitychange", redirectIfAuthorized);
});

function getInvalidEmailMessage(detail: unknown): string | undefined {
  if (!Array.isArray(detail)) return undefined;
  for (const raw of detail) {
    if (!raw || typeof raw !== "object") continue;
    const item = raw as { type?: string; loc?: unknown[] };
    const loc = item.loc;
    const targetsEmail =
      Array.isArray(loc) && loc.some((segment) => segment === "email");
    const isValueError =
      typeof item.type === "string" && item.type.startsWith("value_error");
    if (targetsEmail && isValueError) {
      return "Укажите корректный адрес электронной почты.";
    }
  }
  return undefined;
}

function getPasswordTooShortMessage(detail: unknown): string | undefined {
  if (!Array.isArray(detail)) return undefined;
  for (const raw of detail) {
    if (!raw || typeof raw !== "object") continue;
    const item = raw as {
      type?: string;
      loc?: unknown[];
      ctx?: { min_length?: number };
    };
    const loc = item.loc;
    const targetsPassword =
      Array.isArray(loc) && loc.some((segment) => segment === "password");
    if (!targetsPassword || item.type !== "string_too_short") continue;
    const min = item.ctx?.min_length ?? 8;
    return `Пароль должен содержать не менее ${min} символов.`;
  }
  return undefined;
}

const isFormValid = () => {
  return (
    form.value.email.trim().length > 0 &&
    form.value.password.trim().length > 0 &&
    form.value.fname.trim().length > 0 &&
    form.value.lname.trim().length > 0 &&
    form.value.organization_name.trim().length > 0
  );
};

const signup = () => {
  errorMessage.value = "";
  invalid.value = false;
  invalidEmail.value = false;
  invalidPassword.value = false;

  if (!isFormValid()) {
    invalid.value = true;
    errorMessage.value = "Заполните все поля формы.";
    return;
  }

  isProgress.value = true;

  authStore
    .registerRequest({
      email: form.value.email.trim(),
      password: form.value.password,
      fname: form.value.fname.trim(),
      lname: form.value.lname.trim(),
      organization_name: form.value.organization_name.trim(),
    })
    .then(() => {
      requestSent.value = true;
      redirectIfAuthorized();
    })
    .catch((err) => {
      const status = err.response?.status;
      if (status === 409) {
        errorMessage.value =
          err.response.data?.detail ||
          "Пользователь с таким email или организация уже существует.";
      } else if (status === 422) {
        const detail = err.response?.data?.detail;
        const emailMsg = getInvalidEmailMessage(detail);
        const pwdMsg = getPasswordTooShortMessage(detail);
        if (emailMsg) {
          invalidEmail.value = true;
          errorMessage.value = emailMsg;
        } else if (pwdMsg) {
          invalidPassword.value = true;
          errorMessage.value = pwdMsg;
        } else {
          rootGetters.toast.show(
            "error",
            "Произошла ошибка",
            "Обратитесь к администратору или проверьте соединение с интернетом.",
          );
        }
      } else if (status === 400) {
        const data = err.response?.data;
        if (data?.error_code === "EMAIL_DOMAIN_NOT_ALLOWED") {
          invalidEmail.value = true;
        }
        errorMessage.value =
          data?.detail ||
          "Регистрация с зарубежных почтовых сервисов запрещена. Используйте другой email-адрес.";
      } else {
        rootGetters.toast.show(
          "error",
          "Произошла ошибка",
          "Обратитесь к администратору или проверьте соединение с интернетом.",
        );
      }
    })
    .finally(() => {
      isProgress.value = false;
    });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (isSuccessMessageVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Проверьте почту, мы отправили ссылку для подтверждения. Если письмо не пришло, проверьте папку \"Спам\". "))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_unref(InputText), {
              id: "email",
              modelValue: form.value.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.email) = $event)),
              invalid: invalidEmail.value || invalid.value
            }, null, 8, ["modelValue", "invalid"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_unref(Password), {
              id: "password",
              modelValue: form.value.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password) = $event)),
              feedback: false,
              toggleMask: "",
              invalid: invalidPassword.value
            }, null, 8, ["modelValue", "invalid"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_unref(InputText), {
              id: "fname",
              modelValue: form.value.fname,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.fname) = $event)),
              invalid: invalid.value
            }, null, 8, ["modelValue", "invalid"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_unref(InputText), {
              id: "lname",
              modelValue: form.value.lname,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.lname) = $event)),
              invalid: invalid.value
            }, null, 8, ["modelValue", "invalid"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_unref(InputText), {
              id: "organization_name",
              modelValue: form.value.organization_name,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.organization_name) = $event)),
              invalid: invalid.value
            }, null, 8, ["modelValue", "invalid"])
          ]),
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true),
          _createVNode(_unref(Button), {
            label: "Зарегистрироваться",
            class: "form-button",
            onClick: signup,
            disabled: isProgress.value
          }, null, 8, ["disabled"])
        ])),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_router_link, { to: { name: 'login' } }, {
          default: _withCtx(() => [
            _createTextVNode("Войти")
          ]),
          _: 1
        })
      ])
    ]),
    (isProgress.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_unref(ProgressSpinner), {
            "aria-label": "Loading",
            style: {"width":"30px","height":"30px"},
            strokeWidth: "2",
            fill: "var(--surface-ground)"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})